import { getLogger } from "@/utils/log";

export const logger = getLogger(["backend", "jsdos"]);
export const saveLogger = getLogger(["backend", "jsdos", "save"]);